/** Старые дополнительные колонки больше не являются живыми полями Базы. */
const retired = new Set(['phoneExtra', 'phoneMore', 'spacer']);
export const BASE_PHONE_LAYOUT_VERSION = 2;

/** Обновить старый вид один раз, сохранив порядок остальных колонок. */
export function migrateBasePhoneView<T extends Record<string, unknown>>(view: T): T {
  const result: Record<string, unknown> = structuredClone(view);
  const columns = Array.isArray(view.columns) ? view.columns.filter((key): key is string => typeof key === 'string') : [];
  const hasLegacy = columns.some(key => retired.has(key))
    || Object.keys((view.widths ?? {}) as object).some(key => retired.has(key));
  const first = columns.findIndex(key => key === 'phoneBy' || key === 'phoneRu' || retired.has(key));
  if (hasLegacy && first >= 0) {
    const next = columns.filter(key => !retired.has(key) && key !== 'phoneBy' && key !== 'phoneRu' && key !== 'phoneOther' && key !== 'messenger');
    const before = columns.slice(0, first).filter(key => next.includes(key)).length;
    next.splice(before, 0, 'phoneRu', 'phoneBy', 'phoneOther');
    result.columns = next;
  }
  if (view.basePhoneLayoutVersion !== BASE_PHONE_LAYOUT_VERSION) {
    const selected = Array.isArray(result.columns) ? result.columns as string[] : [];
    const byIndex = selected.indexOf('phoneBy');
    const ruIndex = selected.indexOf('phoneRu');
    if (!selected.includes('phoneOther') && (byIndex >= 0 || ruIndex >= 0)) {
      selected.splice((byIndex >= 0 ? byIndex : ruIndex) + 1, 0, 'phoneOther');
    }
    result.basePhoneLayoutVersion = BASE_PHONE_LAYOUT_VERSION;
  }
  if (view.widths && typeof view.widths === 'object') {
    result.widths = Object.fromEntries(Object.entries(view.widths).filter(([key]) => !retired.has(key)
      && (!hasLegacy || (key !== 'phoneBy' && key !== 'phoneRu'))));
  }
  if (Array.isArray(view.pinned)) result.pinned = view.pinned.filter(key => !retired.has(String(key)));
  else if (view.pinned && typeof view.pinned === 'object') {
    result.pinned = Object.fromEntries(Object.entries(view.pinned).filter(([key]) => !retired.has(key)));
  }
  for (const key of ['sort', 'filters'] as const) {
    if (Array.isArray(view[key])) result[key] = view[key].filter(item => !retired.has(String(item?.field)));
  }
  return result as T;
}
